import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { cancelSubscription } from '../Payment/Stripe/stripe_funcs'
import Modal from '@material-ui/core/Modal';
import {
  Card,
  CardActions,
  CardContent,
  Avatar,
  Typography,
  Divider,
  Button
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  details: {
    display: 'flex'
  },
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    left:'37%',
    top:'40%'
  },
  modalTitle: {
    lineHeight: '2.5rem'
  },
  avatar: {
    marginLeft: 'auto',
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0
  },
  progress: {
    marginTop: theme.spacing(2)
  },
  uploadButton: {
    marginRight: theme.spacing(2)
  }
}));

const AccountProfile = props => {
  const { className, user , ...rest} = props;
  const [modal,setModal] = useState(false)
  const classes = useStyles();
  const avatar = '/images/avatars/avatar.png'
  const cancelSubs = ()=>{
    cancelSubscription(user['sub_id'])
  }
  const body = (
    <div className={classes.paper}>
      <Typography variant="h4" className={classes.modalTitle}>Are you sure?</Typography>
      <Typography className={classes.modalTitle}> We're sad to see you go. </Typography>
      <Button
        style={{marginRight:'15px'}}
        variant="contained"
        onClick={cancelSubs}
      >
        Yes
      </Button>
      <Button
        color="primary"
        variant="contained"
      >
        No
      </Button>
    </div>
  );
  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <div className={classes.details}>
          <div>
            <Typography
              gutterBottom
              variant="h2"
            >
              {user ? user.first_name+' '+user.last_name : ''}
            </Typography>
            <Typography
              gutterBottom
              variant="h5"
            >
              {user.subscribed ? <span style={{color:"green"}}>Premium User</span> : <span style={{color:"red"}}>Not Subscribed Yet</span>}
            </Typography>
            {user.subscribed ? 
              <Typography
                variant="subtitle2">
                {user.sub_info}
              </Typography> : <div></div>
            }
          </div>
          <Avatar
            className={classes.avatar}
            src={avatar}
          />
        </div>
      </CardContent>
      <Divider />
      <CardActions>
        <Button variant="text">Reset Password</Button>
        {user.subscribed ? <Button variant="text" onClick={()=>{setModal(true)}}>Cancel Subscription</Button> : <div></div>}
      </CardActions>
      <Modal
        open={modal}
        onClose={()=>{setModal(false)}}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </Card>
  );
};

AccountProfile.propTypes = {
  className: PropTypes.string
};

export default AccountProfile;
